module.exports = __webpack_public_path__ + "img/1-6.70a46396.png";